<div class="row">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> Listado de Variedades de Especie
            </div>
    
            <div class="card-body-grid" *ngIf="result">
    
                <p-table #tableSearch autoLayout="true" [value]="result?.ResultList" [lazy]="true"
                    [selectionMode]="selectionMode"
                    [(selection)]="arraySelected" dataKey="Id"
                    [lazyLoadOnInit]="false" [rowHover]="true"
                    (onLazyLoad)="onSearchLazy($event)" [paginator]="true" [columns]="cols"
                    [rows]="result?.PageSize" sortOrder="0"
                    [totalRecords]="result?.TotalCount" [loading]="loading"
                    [ngClass]="displayGridHidden(result?.ResultList)"
                    styleClass="table table-responsive-sm table-striped table-sm">
    
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngIf="selectionMode === dialogSelectionMode.Multiple" class="th-md">
                                <p-tableCheckbox (click)="onSelectAll($event)"></p-tableCheckbox>                                
                            </th>
                            <ng-container *ngIf="selectionMode !== dialogSelectionMode.None">
                                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    {{col.header}}
                                </th>
                            </ng-container>
                            <ng-container *ngIf="selectionMode === dialogSelectionMode.None">
                                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}"
                                    [pSortableColumn]="col.field">
                                    {{col.header}}
                                    <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                </th>
                            </ng-container>
                        </tr>
                    </ng-template>
    
                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                        <ng-container *ngIf="selectionMode === dialogSelectionMode.None" >
                            <tr>
                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    <span *ngIf="col.field!=='Link'">
                                        {{rowData[col.field]}}
                                    </span>
                                    <div *ngIf="col.field==='Link' && dialogMode === dialogModeEnum.Basic" class="btn-group">
                                        <button (click)="onEdit(rowData)" type="button" class="btn btn-sm btn-warning" title="Editar">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="selectionMode === dialogSelectionMode.Single" >
                            <tr [pSelectableRow]="rowData" (click)="onSelect($event, rowData)" title="Seleccionar" (dblclick)="onRowDblClick($event, rowData)">
                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    <span *ngIf="col.field!=='Link'">
                                        {{rowData[col.field]}}
                                    </span>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="selectionMode === dialogSelectionMode.Multiple" >
                            <tr [pSelectableRow]="rowData" (click)="onSelect($event, rowData)" title="Seleccionar">
                                <td>
                                    <p-tableCheckbox [value]="rowData" (click)="onSelect($event, rowData)"></p-tableCheckbox>
                                </td>
                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    <span *ngIf="col.field!=='Link'">
                                        {{rowData[col.field]}}
                                    </span>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-template>
                </p-table>
                    
                <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
            </div>
    
        </div>
    </div>
</div>
